<template>
  <div class="container">
    <Header :active="6"></Header>
    <Screen1></Screen1>
    <Screen2></Screen2>
    <Screen3></Screen3>
    <div class="join-link flex-center">
      <router-link to="/join">
        <p class="join-title">加入我们</p>
      </router-link>
    </div>
    <Position></Position>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header/index'
import Screen1 from '../components/AboutUs/screen1'
import Screen2 from '../components/AboutUs/screen2'
import Screen3 from '../components/AboutUs/screen3'
import Position from '../components/Position/index'
import Footer from '../components/Footer/index'
export default {
  components: {
    Header,
    Screen1,
    Screen2,
    Screen3,
    Position,
    Footer
  }
}
</script>